export type CertificationType = '1-on-1 Coaching (Personal Growth & Development)' | '1-on-1 Coaching (Leadership)' | 'Team Coaching';

/**
 * Published platform minimum rate floor in ZAR.
 * Practitioners cannot bill below this floor for sessions booked on the platform.
 * Placeholder set to null pending formal executive publication.
 */
export const PUBLISHED_MINIMUM_RATE_FLOOR_ZAR: number | null = null;

/**
 * Recommended practitioner rate range in ZAR [min, max].
 * Published guideline for standard 1-on-1 and team session rates.
 * Placeholder set to null pending formal executive publication.
 */
export const RECOMMENDED_RATE_RANGE_ZAR: { min: number; max: number } | null = null;

export interface ApprovedRates {
  currency?: 'ZAR' | 'USD';
  oneOnOneRate?: number | null;
  teamRate?: number | null;
  description?: string;
  [key: string]: any;
}

/** @deprecated Alias for backwards compatibility */
export type CoachingPricing = ApprovedRates;

export interface Practitioner {
  id: string;
  name: string;
  location: string;
  specialisms: string[];
  website?: string;
  bio: string;
  photoUrl?: string;
  certificationLevel: string;
  certifications: CertificationType[];
  status: 'draft' | 'active' | 'paused';
  approvedRates?: ApprovedRates;
  bookingUrl?: string;
  schedulingUrl?: string;
  deliveryMode?: string;
  languages?: string[];
}

export const practitioners: Practitioner[] = [];


